<template>
  <div class="print-layout">
    <slot />
  </div>
</template>

<style scoped>
.print-layout {
  width: 100%;
  min-height: 100vh;
}
</style>
